import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

function isStandaloneLaunch() {
  return (
    window.matchMedia("(display-mode: standalone)").matches ||
    window.navigator.standalone === true
  );
}

// Soft splash moment shown only when DreamWeaver is launched from the
// home-screen icon (standalone display mode) - regular browser tab visits
// skip it entirely.
export default function SplashScreen() {
  const [visible, setVisible] = useState(() => isStandaloneLaunch());

  useEffect(() => {
    if (!visible) return;
    const timer = setTimeout(() => setVisible(false), 1700);
    return () => clearTimeout(timer);
  }, [visible]);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="splash-screen"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.6, ease: "easeInOut" }}
          className="fixed inset-0 z-[200] flex flex-col items-center justify-center bg-[#0B091A]"
        >
          <motion.div
            initial={{ scale: 0.85, opacity: 0 }}
            animate={{ scale: [0.85, 1, 0.96, 1], opacity: 1 }}
            transition={{ duration: 1.5, times: [0, 0.45, 0.75, 1], ease: "easeInOut" }}
            className="relative"
          >
            <div className="absolute inset-0 -m-6 rounded-full blur-2xl bg-gradient-to-br from-purple-600/40 to-amber-400/40" />
            <img src="/icon-512.png" alt="" className="relative w-24 h-24 rounded-3xl shadow-2xl shadow-purple-900/50" />
          </motion.div>
          <motion.p
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4, duration: 0.6 }}
            className="mt-6 font-serif text-2xl font-bold gradient-text"
          >
            DreamWeaver
          </motion.p>
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.75, duration: 0.6 }}
            className="mt-2 text-xs tracking-[0.2em] uppercase text-slate-500"
          >
            Tucking you in...
          </motion.p>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
